module.exports = __webpack_public_path__ + "static/media/propic-2.14b67869.png";